var exports = {
  "Nr": "StreamSpectatorsPopout.module__card___c3RKSW",
  "wx": "StreamSpectatorsPopout.module__header___c3RKSW",
  "p_": "StreamSpectatorsPopout.module__list___c3RKSW",
  "QC": "StreamSpectatorsPopout.module__spectatorRow___c3RKSW",
  "zh": "StreamSpectatorsPopout.module__spectatorName___c3RKSW",
  "e": "StreamSpectatorsPopout.module__spectatorDevice___c3RKSW",
};

module.exports = exports;
